export default __webpack_public_path__ + "static/media/desk07.6484889e.jpg";